import gql from 'graphql-tag';
import { apolloClient } from '../../../App';

import { GET_SITES_QUERY } from 'data/queries/site';

import { GetSitesQuery, SitesUpdatedSubscription, UpdateSiteMutation } from 'data/__generated__';

export const sitesUpdatedHandler = (siteUpdated: UpdateSiteMutation['updateSite']['site']) => {
    if (!siteUpdated) {
        return;
    }
    let currentSites = [] as GetSitesQuery['sites'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetSitesQuery>({ query: GET_SITES_QUERY });
        if (!result) {
            throw Error('An error occurred when reading GET_SITES_QUERY');
        }
        currentSites = result.sites;
    } catch {
        // do nothing
    }
    const siteIds = currentSites.map(({ _id }) => _id);

    if (siteIds.includes(siteUpdated._id)) {
        // If this is a site existing in the cache
        const data = currentSites.map((site) => {
            if (site._id === siteUpdated._id) {
                return siteUpdated;
            }
            return site;
        });
        apolloClient.writeQuery({
            query: GET_SITES_QUERY,
            data,
        });
    } else {
        // If this is a new site, not present in the cache
        const data = {
            sites: [...currentSites, siteUpdated],
        };
        apolloClient.writeQuery({
            query: GET_SITES_QUERY,
            data,
        });
    }
};

export const siteUpdatedHandler = (siteUpdated: SitesUpdatedSubscription['siteUpdated'], siteId: string) => {
    const data = {
        site: siteUpdated,
    };
    apolloClient.writeFragment({
        id: siteId,
        fragment: gql`
            fragment SitePartialFragmentFragment on Site {
                name
                state
            }
        `,
        data,
    });
};
